<template>
  <div class="content-wrapper">
    <section class="content-header">
      <div class="container-fluid">
        <div class="row mb-2">
          <div class="col-sm-6">
            <h1>Student List</h1>
          </div>
          <div class="col-sm-6">
            <ol class="breadcrumb float-sm-right">
              <li class="breadcrumb-item">
                <router-link :to="{ name: 'Home' }">Home</router-link>
              </li>
              <li class="breadcrumb-item">Reports</li>
              <li class="breadcrumb-item active">Student List</li>
            </ol>
          </div>
        </div>
      </div>
    </section>

    <section class="content">
      <div class="container-fluid">
        <div class="card">
          <div class="card-header">
            <a
              href="javascript:void(0)"
              class="btn btn-info"
              @click="showFilter = !showFilter"
              ><i class="fa fa-filter"></i>Filter</a
            >
          </div>
          <form @submit.prevent="getFilterData()" method="GET" novalidate>
            <div class="card-body" v-if="showFilter">
              <div class="row">
                <div class="col-md-6">
                  <div class="form-group form-row">
                    <label class="col-md-3 col-form-label" for="username"
                      >Username</label
                    >
                    <div class="col-md-9">
                      <input
                        type="text"
                        id="username"
                        class="form-control"
                        v-model="filter.username"
                        placeholder="Username"
                      />
                    </div>
                  </div>
                  <div class="form-group form-row">
                    <label class="col-md-3 col-form-label" for="name"
                      >Name</label
                    >
                    <div class="col-md-9">
                      <input
                        type="text"
                        id="name"
                        class="form-control"
                        v-model="filter.name"
                        placeholder="Name"
                      />
                    </div>
                  </div>
                  <div class="form-group form-row">
                    <label class="col-md-3 col-form-label" for="mobile_no"
                      >Mobile</label
                    >
                    <div class="col-md-9">
                      <input
                        type="text"
                        id="mobile_no"
                        class="form-control"
                        v-model="filter.mobile_no"
                        placeholder="Mobile no"
                      />
                    </div>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group form-row">
                    <label class="col-md-3 col-form-label" for="email"
                      >Email</label
                    >
                    <div class="col-md-9">
                      <input
                        type="text"
                        id="email"
                        class="form-control"
                        v-model="filter.email"
                        placeholder="Email"
                      />
                    </div>
                  </div>
                  <div class="form-group form-row">
                    <label class="col-md-3 col-form-label" for="created_at"
                      >Date range</label
                    >
                    <div class="col-md-9">
                      <date-picker
                        type="datetime"
                        input-class="form-control"
                        v-model="filter.created_at"
                        range
                        lang="en"
                        format="YYYY-MM-DD hh:mm:ss"
                        confirm
                        id="created_at"
                        value-type="YYYY-MM-DD hh:mm:ss"
                      ></date-picker>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-6">
                  <div class="row">
                    <div class="col-md-9 offset-md-3">
                      <button type="submit" class="btn btn-common m-2px">
                        Search
                      </button>
                      <button
                        type="reset"
                        class="btn btn-warning"
                        @click="resetFilter()"
                      >
                        Reset
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </form>
          <div class="overlay" v-if="is_loading">
            <i class="fas fa-2x fa-sync-alt fa-spin"></i>
          </div>
          <div class="card-body table-responsive-md p-0">
            <table class="table">
              <thead>
                <tr>
                  <th style="width: 10px">ID</th>
                  <th>Name</th>
                  <th>Username</th>
                  <th>Mobile No.</th>
                  <th>Email</th>
                  <th>Created At</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(student, index) in students.data">
                  <td>{{ student.id }}</td>
                  <td>{{ student.name }}</td>
                  <td>{{ student.username }}</td>
                  <td>{{ student.mobile_no }}</td>
                  <td>{{ student.email }}</td>
                  <td>{{ student.created_at }}</td>
                </tr>
              </tbody>
            </table>

            <div class="p-4" v-if="_.isEmpty(students.data)">
              <div class="alert alert-default-warning" role="alert">
                No data found!
              </div>
            </div>
          </div>
          <div class="card-footer">
            <vue-pagination
              :pagination="students"
              v-if="students.total > students.per_page"
              @paginate="getStudents()"
            />
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import VuePagination from "@/components/partials/PaginationComponent";
import { LearningReportApi } from "@/services/api";

import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";

export default {
  name: "StudentList",
  metaInfo: {
    title: "Student List | Dotlines",
  },
  components: {
    DatePicker,
    VuePagination,
  },
  data: () => ({
    students: {
      total: 0,
      per_page: 1,
      from: 1,
      to: 0,
      current_page: 1,
    },
    showFilter: false,
    filter: {},
    is_loading: false,
  }),
  methods: {
    getStudents() {
      this.filter = JSON.parse(JSON.stringify(this.$route.query));
      if (!_.isEmpty(this.filter)) this.showFilter = true;
      this.is_loading = true;
      let params = { ...this.filter, ...this.$route.query };
      LearningReportApi.studentList(params)
        .then((students) => {
          this.students = students;
        })
        .finally(() => {
          this.is_loading = false;
        });
    },

    resetFilter() {
      this.$router.push({ path: this.$route.path }).catch(() => {});
    },
    async getFilterData() {
      console.log(this.filter);
      this.$router
        .push({
          path: this.$route.fullPath,
          query: this.filter,
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
  mounted() {
    this.getStudents();
  },
};
</script>
